const initialState = {
  success: false,
  loading: false,
  error: null,
  totalETI: {
    data: null,
    loading: false,
    error: null,
  },
  totalETO: {
    data: null,
    loading: false,
    error: null,
  },
  totalPaidUnpaidPendingTax: {
    data: null,
    loading: false,
    error: null,
  },
  adminUsersList: {
    data: null,
    loading: false,
    error: null,
  },
  totalRegisterPropertiesFiscalYear: {
    data: null,
    loading: false,
    error: null
  }
};

const homePageReducer = (
  state = initialState,
  { obj, type, error, payload, data }
) => {
  switch (type) {
    case 'GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR':
      return {
        ...state,
        totalRegisterPropertiesFiscalYear: {
          ...state.totalRegisterPropertiesFiscalYear,
          loading: true,
        }
      }

    case 'GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR_SUCCESS':
      return {
        ...state,
        totalRegisterPropertiesFiscalYear: {
          ...state.totalRegisterPropertiesFiscalYear,
          loading: false,
          data,
        }
      }


    case 'GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR_FAIL':
      return {
        ...state,
        totalRegisterPropertiesFiscalYear: {
          ...state.totalRegisterPropertiesFiscalYear,
          loading: false,
          error,
        }
      }
    case "RESET_ADMIN":
      return initialState;

    case "GET_TOTAL_PAID_UNPAID_PENDING_TAX":
      return {
        ...state,
        totalPaidUnpaidPendingTax: {
          ...state.totalPaidUnpaidPendingTax,
          loading: true,
        },
      };

    case "GET_TOTAL_PAID_UNPAID_PENDING_TAX_SUCCESS":
      return {
        ...state,
        totalPaidUnpaidPendingTax: {
          ...state.totalPaidUnpaidPendingTax,
          data,
          loading: false,
        },
      };

    case "GET_TOTAL_PAID_UNPAID_PENDING_TAX_FAIL":
      return {
        ...state,
        totalPaidUnpaidPendingTax: {
          ...state.totalPaidUnpaidPendingTax,
          error,
          loading: false,
        },
      };

    case "GET_TOTAL_ETI":
      return {
        ...state,
        totalETI: {
          ...state.totalETI,
          loading: true,
        },
      };

    case "GET_TOTAL_ETI_SUCCESS":
      return {
        ...state,
        totalETI: {
          ...state.totalETI,
          data,
          loading: false,
        },
      };

    case "GET_TOTAL_ETI_FAIL":
      return {
        ...state,
        totalETI: {
          ...state.totalETI,
          error,
          loading: false,
        },
      };

    case "GET_TOTAL_ETO":
      return {
        ...state,
        totalETO: {
          ...state.totalETO,
          loading: true,
        },
      };

    case "GET_TOTAL_ETO_SUCCESS":
      return {
        ...state,
        totalETO: {
          ...state.totalETO,
          data,
          loading: false,
        },
      };

    case "GET_TOTAL_ETO_FAIL":
      return {
        ...state,
        totalETO: {
          ...state.totalETO,
          error,
          loading: false,
        },
      };

    case "GET_ADMIN_USERS_LIST":
      return {
        ...state,
        adminUsersList: {
          ...state.adminUsersList,
          loading: true,
        },
      };

    case "GET_ADMIN_USERS_LIST_SUCCESS":
      return {
        ...state,
        adminUsersList: {
          ...state.adminUsersList,
          data,
          loading: false,
        },
      };

    case "GET_ADMIN_USERS_LIST_FAIL":
      return {
        ...state,
        adminUsersList: {
          ...state.adminUsersList,
          error,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default homePageReducer;
